export enum DecisionViews {
  'PROGRAMS' = 'PROGRAMS',
  'LOAN-CONDITIONS' = 'LOAN-CONDITIONS',
  'LOAN-CONFIRMATION' = 'LOAN-CONFIRMATION',
  'CHOOSE-DELIVERY-ADDRESS' = 'CHOOSE-DELIVERY-ADDRESS'
}

export enum DecisionSubViews {
  'CHOOSE-PROPERTY-PLEDGE' = 'CHOOSE-PROPERTY-PLEDGE',
  'CHOOSE-LOAN-PARAMS' = 'CHOOSE-LOAN-PARAMS',
  'UPGRADE-OWN-WITH-PLEDGE-PROGRAM' = 'UPGRADE-OWN-WITH-PLEDGE-PROGRAM'
}

export enum InsuranceCompanies {
  freedom = 'freedom',
  other = 'other'
}
